import { Box, getBoundingBox } from "@/features/Editor/Canvas/canvas-geometry";
import type { CanvasElement } from "./canvas-state";
import type { ElementDraft } from "@repo/video-engine-i2v/utils/element-draft";

export function getSelectedBoxes(
  canvasElements: CanvasElement[],
  selectedIds: string[],
  drafts: Record<string, ElementDraft> = {},
): Box[] {
  return canvasElements
    .filter(({ externalId }) => selectedIds.includes(externalId))
    .map(({ externalId, box }) => drafts[externalId] ?? box);
}

export function getSelectionBox(
  canvasElements: CanvasElement[],
  selectedIds: string[],
) {
  return getBoundingBox(getSelectedBoxes(canvasElements, selectedIds));
}

export function haveSameMembers(a: string[], b: string[]) {
  return a.length === b.length && a.every((id) => b.includes(id));
}
